import { render, staticRenderFns } from "./MarkdownView.vue?vue&type=template&id=5112a22c&scoped=true"
import script from "./MarkdownView.vue?vue&type=script&lang=js"
export * from "./MarkdownView.vue?vue&type=script&lang=js"
import style0 from "./MarkdownView.vue?vue&type=style&index=0&id=5112a22c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5112a22c",
  null
  
)

export default component.exports